
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';


export interface CapitalisationRecordLinkInput {
  group_index: number
  pp: number
  np: number
  u: number
}

export interface CapitalisationRecordInput {
  id: string
  name: string
  links: CapitalisationRecordLinkInput[]
}

export interface CapitalisationInput {
  groups: string[]
  records: CapitalisationRecordInput[]
}


const importCapitalisationMatrixMutation = require('./gql/import-capitalisation-matrix.mutation.gql');

/**
 * Service to import capitalisation matrix
 */
@Injectable()
export class CapitalisationService {

  constructor(private apollo: Apollo) { }

  importCapitalisationMatrix(dossier_id: string, input: CapitalisationInput): Observable<string> {
    return this.apollo
      .mutate({
        mutation: importCapitalisationMatrixMutation,
        variables: {
          dossier_id,
          input
        }
      }).pipe(
      map(result => result.data['importCapitalisationMatrix']));
  }
}